@use "/src/styles/functions";
@use "/src/styles/mixins";

.allButtons {
  display: flex;

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    border: 1px solid functions.getThemeColor(stroke-soft-200);
    background-color: functions.getThemeColor(bg-white-0);
    color: functions.getThemeColor(text-sub-600);
    overflow: hidden;

    &:not(:first-child) {
      border-right: none;
    }

    &:first-child {
      border-top-right-radius: functions.space(8);
      border-bottom-right-radius: functions.space(8);
    }

    &:last-child {
      border-top-left-radius: functions.space(8);
      border-bottom-left-radius: functions.space(8);
    }

    .button__container {
      display: flex;
      align-items: center;
    }

    .icon {
      flex: 0 0 auto;
    }

    &:hover {
      background-color: functions.getThemeColor(bg-weak-50);
    }
    &:active {
      background-color: functions.getThemeColor(bg-weak-50);
      color: functions.getThemeColor(text-strong-900);
    }

    &:disabled {
      background-color: functions.getThemeColor(bg-weak-50);
      border: none;
      color: functions.getThemeColor(text-disabled-300);
    }

    &[data-size="medium"] {
      padding: functions.space(10) functions.space(18);
    }

    &[data-size="small"] {
      padding: functions.space(8) functions.space(16);
    }

    &[data-size="x-small"] {
      padding: functions.space(6) functions.space(14);
    }

    &[data-size="2x-small"] {
      padding: functions.space(4) functions.space(12);
    }
  }
}
